/* DaoCharm new arrivals, best sellers and source-related recommendations. */
(() => {
  'use strict';
  const valid = h => typeof h==='string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(h);
  const getHistory = () => {
    try {
      const items=JSON.parse(localStorage.getItem('dcRecentProductsV2')||'[]');
      return Array.isArray(items)?items.filter(x=>x && valid(x.handle)):[];
    } catch(e) { return []; }
  };
  function setupCarousel(region) {
    if (region.dataset.dcCarouselReady) return;
    const track = region.querySelector('[data-dc-commerce-track]');
    const controls = region.querySelector('[data-dc-commerce-controls]');
    const prev = region.querySelector('[data-dc-commerce-prev]');
    const next = region.querySelector('[data-dc-commerce-next]');
    const count = region.querySelector('[data-dc-commerce-count]');
    if (!track || !controls || !prev || !next || !count) return;
    const cards = [...track.querySelectorAll(':scope > [data-dc-hero-slide]')];
    if (!cards.length) { controls.hidden = true; return; }

    // Release the server-side loading fallback and use a real scrollable rail.
    // All three products remain in normal layout; no display swaps or cut scenes.
    cards.forEach((card, i) => {
      card.hidden = false;
      card.style.removeProperty('display');
      card.style.removeProperty('position');
      card.removeAttribute('inert');
      card.removeAttribute('aria-hidden');
      // Language-neutral slide position (no hard-coded English).
      card.setAttribute('aria-label', (i + 1) + ' / ' + cards.length);
    });
    track.dataset.dcSlideRail = 'true';
    region.dataset.dcCarouselReady = '1';
    track.scrollLeft = 0;

    let index = 0;
    let lastManual = 0;
    let interacting = false;
    let touchActive = false;
    let scrollFrame = 0;
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const points = () => {
      const firstLeft = cards[0].offsetLeft;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      return cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - firstLeft)));
    };
    function sync() {
      const targets = points();
      let nearest = 0;
      let distance = Infinity;
      targets.forEach((left, i) => {
        const d = Math.abs(track.scrollLeft - left);
        if (d < distance) { distance = d; nearest = i; }
      });
      index = nearest;
      controls.hidden = cards.length <= 1;
      count.textContent = (index + 1) + ' / ' + cards.length;
      prev.disabled = index === 0;
      next.disabled = index === cards.length - 1;
    }
    function goTo(target, manual) {
      if (manual) lastManual = Date.now();
      const bounded = Math.max(0, Math.min(cards.length - 1, target));
      if (bounded === index && Math.abs(track.scrollLeft - points()[bounded]) < 2) return;
      index = bounded;
      count.textContent = (index + 1) + ' / ' + cards.length;
      prev.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      track.scrollTo({
        left: points()[bounded] || 0,
        behavior: reduced() ? 'instant' : 'smooth'
      });
    }
    prev.addEventListener('click', () => goTo(index - 1, true));
    next.addEventListener('click', () => goTo(index + 1, true));
    track.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(sync);
    }, { passive: true });
    // Keep the landing carousel's interrupt-settle-resume gesture lifecycle.
    function settleInterruptedScroll() {
      const targets = points();
      let nearest = 0;
      let distance = Infinity;
      targets.forEach((left, i) => {
        const delta = Math.abs(track.scrollLeft - left);
        if (delta < distance) { distance = delta; nearest = i; }
      });
      track.scrollTo({ left: targets[nearest] || 0, behavior: 'instant' });
      sync();
    }
    function startInteraction() {
      if (interacting) return;
      interacting = true;
      lastManual = Date.now();
      settleInterruptedScroll();
    }
    function finishInteraction() {
      if (!interacting) return;
      interacting = false;
      lastManual = Date.now();
    }
    track.addEventListener('pointerdown', startInteraction, { passive: true });
    track.addEventListener('pointerup', finishInteraction, { passive: true });
    track.addEventListener('pointercancel', finishInteraction, { passive: true });
    window.addEventListener('pointerup', finishInteraction, { passive: true });
    window.addEventListener('pointercancel', finishInteraction, { passive: true });
    track.addEventListener('touchstart', () => { touchActive = true; lastManual = Date.now(); }, { passive: true });
    track.addEventListener('touchend', () => { touchActive = false; lastManual = Date.now(); }, { passive: true });
    track.addEventListener('touchcancel', () => { touchActive = false; lastManual = Date.now(); }, { passive: true });
    track.addEventListener('scrollend', () => {
      if (!interacting && !touchActive) settleInterruptedScroll();
    }, { passive: true });
    track.addEventListener('wheel', () => { lastManual = Date.now(); }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(index + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    window.addEventListener('resize', () => {
      // A responsive width change preserves which product is selected.
      track.scrollTo({ left: points()[index] || 0, behavior: 'instant' });
      sync();
    }, { passive: true });
    sync();

    if (cards.length > 1) {
      const timer = window.setInterval(() => {
        if (!region.isConnected) { clearInterval(timer); return; }
        const rect = region.getBoundingClientRect();
        // Autoplay stays active on mobile and in draft previews. A tap/swipe
        // temporarily pauses it; keyboard focus or sticky touch-hover does not.
        if (document.hidden || interacting || touchActive || Date.now() - lastManual < 3000 ||
            rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        // All transitions use the rail's smooth horizontal motion, not hard swaps.
        goTo(index === cards.length - 1 ? 0 : index + 1, false);
      }, 3000);
    }
  }
  function setupRecommendation(section) {
    if(section.dataset.dcRecsReady)return;
    section.dataset.dcRecsReady='1';
    const grid=section.querySelector('[data-dc-recommendation-grid]');
    if(!grid)return;
    const cards=[...grid.querySelectorAll(':scope > .dc-market__product')];
    if(!cards.length)return;
    let history=getHistory();
    let handle=history[0]?.handle||'';
    try{
      const qs=new URLSearchParams(location.search);
      const direct=qs.get('viewed_product')||qs.get('product_handle');
      if(valid(direct))handle=direct;
      else {
        const ref=new URL(document.referrer);
        const found=ref.origin===location.origin && ref.pathname.match(/\/products\/([a-z0-9-]+)/);
        if(found && valid(found[1]))handle=found[1];
      }
    }catch(e){}
    if(!valid(handle))try{handle=sessionStorage.getItem('dc_recent_handle')||''}catch(e){}
    const origin=cards.find(c=>c.dataset.dcHandle===handle);
    const targetType=origin?.dataset.dcType||'';
    const targetTags=String(origin?.dataset.dcTags||'').split(',').filter(Boolean);
    const sold=c=>Number(c.dataset.dcSold)||0;
    function affinity(c){
      if(!origin)return 0;
      if(c.dataset.dcHandle===handle)return -10000;
      let result=0;
      if(targetType && targetType===c.dataset.dcType)result+=10000;
      const tags=String(c.dataset.dcTags||'').split(',');
      result+=tags.filter(tag=>tag&&targetTags.includes(tag)).length*800;
      return result;
    }
    cards.sort((a,b)=>affinity(b)-affinity(a)||sold(b)-sold(a)||a.dataset.dcHandle.localeCompare(b.dataset.dcHandle));
    cards.forEach(c=>grid.appendChild(c));
    const hint=section.querySelector('[data-dc-recs-reason]');
    if(hint)hint.textContent=origin?section.closest('.dc-market')?.dataset.dcRecsInspired||'':section.closest('.dc-market')?.dataset.dcRecsPopular||'';
  }
  function init() {
    document.querySelectorAll('.dc-market [data-dc-commerce-carousel]').forEach(setupCarousel);
    document.querySelectorAll('.dc-market .dc-market__behavior-recs').forEach(setupRecommendation);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
